import React, {Component} from 'react';
import './machines.css';
import MachineSmall from "./MachineSmall";
import MachineMedium from "./MachineMedium";
import MachineTable from "./MachineTable";
import Job from "../../utils/Job";
import MachineDetailView from "./MachineDetailView";
import PropTypes from 'prop-types';
import Machines from "../../utils/entities/Machines";
import ModuleNav from "../../mainFrame/ModuleNav";
import Api from "../../utils/Api";
import MachineStates from "../../utils/MachineStates";
import MachineHideSelector from "../../utils/MachineHideSelector";
import LocationSelector from "../../globalComponents/LocationSelector";

class MachineContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
        pastTimeOfInactivity: PropTypes.number.isRequired,
        setMachineHideTime: PropTypes.func.isRequired,
        requestMachines: PropTypes.func.isRequired
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.currentCompany = (this.props.baseData.companies && this.props.baseData.companies.initialized) ? this.props.baseData.companies.getCurrentCompany() : null;

        this.state = {
            activeView: 'smallView',
            selectedLocationId: 0,
            machineOperators: [],
            stitchesAndThreadbreaks: []
        };

        this.translate = this.props.baseData.translate;

        this.updateMachines = this.updateMachines.bind(this);
        this.updateOperators = this.updateOperators.bind(this);
        this.updateStitchesAndThreadbreaks = this.updateStitchesAndThreadbreaks.bind(this);
        this.getMachineIds = this.getMachineIds.bind(this);
        this.onTableClick = this.onTableClick.bind(this);
        this.setModalContent = this.setModalContent.bind(this);
        this.handleViewChange = this.handleViewChange.bind(this);

        this.updateMachinesJob = new Job(this.updateMachines, 5000);
        //this.updateOperatorsJob = new Job(this.updateOperators, 5000);
        this.updateStitchesAndThreadbreaksJob = new Job(this.updateStitchesAndThreadbreaks, 5000);

    }

    componentDidMount() {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const state = {...this.state};

        //  View aus den userprops laden
        const activeView = (settings.viewMachines) ? settings.viewMachines : 'smallView';

        if (activeView) state.activeView = activeView;

        // Standort aus den userprops laden
        const locationId = (settings.viewLocation) ? settings.viewLocation : null;

        if (locationId !== null) state.selectedLocationId = locationId;

        this.setState(state);

        this.updateMachinesJob.start(true);
        //this.updateOperatorsJob.start(true);
        this.updateStitchesAndThreadbreaksJob.start(true);

    }

    componentWillUnmount() {

        this.updateMachinesJob.stop();
        //this.updateOperatorsJob.stop();
        this.updateStitchesAndThreadbreaksJob.stop();

    }

    componentDidUpdate(prevProps) {

        let c = (this.props && this.props.baseData.companies && this.props.baseData.companies.initialized) ? this.props.baseData.companies.getCurrentCompany() : null;

    }

    updateMachines() {

        this.props.requestMachines();

    }

    updateOperators() {

        const machineIds = this.getMachineIds();

        const params = {
            action: 'machineOperators',
            machineIds: machineIds,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    machineOperators: res
                });
            }
        }.bind(this);

        //  TODO: Wenn der Operator in der Machine-Table nicht funktionieren sollte, hier weitermachen!
        //this.api.request('GetOperator', params, callback, null);

    }

    updateStitchesAndThreadbreaks() {

        const machineIds = this.getMachineIds();

        const currentCompany = (this.props.baseData.companies && this.props.baseData.companies.initialized) ? this.props.baseData.companies.getCurrentCompany() : null;
        if (!currentCompany) return;

        const params = {
            companyId: currentCompany.id,
            machineIds: machineIds,
            from: Date.now() - (1000 * 24 * 60 * 60),
            till: Date.now(),
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    stitchesAndThreadbreaks: res,
                });
            }
        }.bind(this);

        this.api.request('GetStitchesAndThreadbreaks', params, callback, null);

    }

    getMachineIds() {

        if(!(this.props.machines && this.props.machines.machines)) return [];

        //const machines = this.props.machines.machines;
        const machines = this.props.machines.machines.filter(function(e){ return e === 0 || e });

        return machines.map(
            (m) => {
                return m.machine_id;
            }
        );

    }

    handleViewChange(view) {

        if (view) {
            this.props.baseData.saveSettings('viewMachines', view);

            this.setState({activeView: view});
        }

    }

    locationSelected(location) {

        const newLocationId = (location) ? location.id : 0;

        this.setState({selectedLocationId: newLocationId});

        this.props.baseData.saveSettings('viewLocation', newLocationId);

    }

    onTableClick(machineId) {

        let machines = this.props.machines.getAllMachines();
        let machineSelected = null;

        machines.forEach((machine) => {
            if (machine.machine_id === machineId) {
                machineSelected = machine;
            }
        });

        if (machineSelected) this.setModalContent(machineSelected);

        return null;

    }

    setModalContent(m) {

        if (!m) return null;

        this.props.baseData.modalData({
            content: <MachineDetailView
                baseData={this.props.baseData}
                machine={m}
                machineCounter={this.props.machines.getAllOrderedMachineIds().length}
            />
        });

    }

    renderLegendArea() {

        const items = MachineStates.getLegendPanel();

        let legendPanel = [];

        if (!items) return null;

        for (let ix in items) {
            let item = items[ix];
            let classes = ['status', item.code].join(' ').trim();

            legendPanel.push(<span key={'legend-' + ix} className={classes}><i>ok</i> {this.translate(item.translationKey)}</span>);
        }

        return legendPanel;

    }

    renderMachines() {

        if (this.state.activeView === null) return null;

        const data = this.props.machines.getMachinesByLocationId(this.state.selectedLocationId);

        if (data.length > 0) {
            let activeView = this.state.activeView;

            if (activeView === 'smallView') {
                return data.map(
                    (m) => <MachineSmall
                        key={m.id}
                        baseData={this.props.baseData}
                        machine={m}
                        onClick={this.setModalContent}
                    />
                );
            } else if (activeView === 'mediumView') {
                return data.map(
                    (m) => <MachineMedium
                        key={m.id}
                        baseData={this.props.baseData}
                        machine={m}
                        stitchesAndThreadbreaks={this.state.stitchesAndThreadbreaks}
                        translate={this.translate}
                        onClick={this.setModalContent}
                    />
                );
            } else if (activeView === 'tableView') {
                return (
                    <MachineTable
                        baseData={this.props.baseData}
                        machines={data}
                        translate={this.translate}
                        onClick={this.onTableClick}
                    />
                );
            }

            return <span className="warningBox">{this.translate('noViewFound')}</span>;
        }

        return <span className="warningBox">{this.translate('noMachineFound')}</span>;

    }

    render() {

        const legendPanel = this.renderLegendArea();
        const archivAreaClasses = ['archivArea', 'clearfix', this.state.activeView].join(' ').trim();
        const machines = this.renderMachines();

        return (
            <div className="machineContainer">
                <nav>
                    <h1>{this.translate('machines')}</h1>

                    <ModuleNav
                        translate={this.translate}
                        activeView={this.state.activeView}
                        onClick={this.handleViewChange}
                    />

                    <MachineHideSelector
                        translate={this.translate}
                        selected={this.props.pastTimeOfInactivity}
                        onClick={this.props.setMachineHideTime}
                    />

                    <span style={{float: 'right'}}>
                        <LocationSelector
                            baseData={this.props.baseData}
                            currentLocation={this.state.selectedLocationId}
                            allLabel={'allLocations'}
                            placeholder={this.translate('select') + '...'}
                            onLocationSelected={(location) => this.locationSelected(location)}
                        />
                    </span>
                </nav>

                <div className="legendArea">
                    {legendPanel}
                </div>

                <div className={archivAreaClasses}>
                    {machines}
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('analysis')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );
    }
}

export default MachineContainer;